module.exports = __webpack_public_path__ + "img/hello.4cfb2e31.gif";